module.exports = __webpack_public_path__ + "media/images/dessi-5a3feb28e7fef96f0a275a1e86aaf567.jpeg";